/**
 * Человеческие подписи ролей — одно имя роли, одна подпись во всей админке
 * (подвал сайдбара, переключатель пользователей, баннер просмотра).
 *
 * ⛔ `prv3` (07.09.2026): подписи приезжают с сервера (`/auth/me` → `role_labels`), где
 * живут в базе и правятся строкой без выката. Здесь — только запас на случай, когда
 * ответ ещё не пришёл; список из ПЯТИ имён знал не все семь ролей боя, и «Мастер» с
 * «Медперсоналом» показывались машинными строками (op-rules §31).
 */
const ROLE_TITLES: Record<string, string> = {
  super_admin: 'Владелец',
  admin: 'Администратор',
  editor: 'Редактор сайтов',
  directolog: 'Директолог',
  manager: 'Менеджер',
  master: 'Мастер',
  med: 'Медперсонал',
};

/**
 * Подписи, приехавшие с сервера, — общий кэш модуля.
 *
 * Он нужен, чтобы бейдж роли оставался ПРОСТЫМ компонентом: подтягивать в него ответ
 * сервера через хук значило бы тащить в каждый крошечный бейдж провайдер запросов, и
 * компонент переставал бы рисоваться где угодно. Кэш наполняет `useAuth`, а до первого
 * ответа работает канон ниже — экран не пустеет.
 */
let sServera: Record<string, string> = {};

/** Запомнить подписи ролей из ответа сервера (`/auth/me` → `role_labels`). */
export function zapomnitPodpisiRoley(podpisi?: Record<string, string>): void {
  if (podpisi && Object.keys(podpisi).length > 0) {
    sServera = podpisi;
  }
}

/** Подпись одной роли; незнакомая роль показывается как есть (§31.2). */
export function roleTitle(role: string, izOtveta?: Record<string, string>): string {
  return izOtveta?.[role] ?? sServera[role] ?? ROLE_TITLES[role] ?? role;
}

/** Подпись пользователя по набору его ролей. Без ролей — «Команда». */
export function roleLabel(
  roles: string[] | undefined,
  isSuperAdmin = false,
  izOtveta?: Record<string, string>,
): string {
  if (isSuperAdmin || roles?.includes('super_admin')) return roleTitle('super_admin', izOtveta);
  const first = roles?.[0];
  return first ? roleTitle(first, izOtveta) : 'Команда';
}
